import * as React from 'react';
import * as Core from 'components/core';
import { Cart } from 'types/cart';
type Props = {
  cart: Cart | undefined | null;
  checkoutComplete: boolean;
};
export default class CartLink extends React.Component<Props> {
  render() {
    const { cart, checkoutComplete } = this.props;
    const productLineItems =
      cart != null &&
      cart.LineItems != null &&
      cart.LineItems.filter((lineItem) => {
        return (
          lineItem.Type === 'product' || lineItem.Type === 'license-upgrade'
        );
      });
    if (!checkoutComplete && productLineItems && productLineItems.length > 0) {
      return (
        <Core.Link
          className="Header-nav-items-link bg-accent-color-one px-3 py-1 rounded-full text-slate-800 font-bold"
          to="/checkout/"
        >
          Cart
        </Core.Link>
      );
    } else {
      return null;
    }
  }
}
